export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';

export const updateTransaction = (payload) => (dispatch) => dispatch({
	type: UPDATE_TRANSACTION,
	payload
});
